<template>
    <div class="view-more" :class="{ fold: showMore && fold, [mode]: true }">
        <div
            ref="ref_content"
            class="view-more-content"
            :style="showMore && styleObject"
            v-html="content"
        ></div>
        <div
            role="button"
            tabindex="0"
            class="more-btn"
            v-show="showMore && !personalWebsite"
            @click="collapse(!fold)"
        >
            {{ showMoreOrLess }}
        </div>
    </div>
</template>

<script>
import util from '../common/util';
import global from '../common/global';

export default {
    i18next: {
        ns: 'common'
    },
    emits: ['collapse'],
    props: {
        line: {
            type: Number,
            default: 2
        },
        mobileLine: {
            type: Number,
            default: 2
        },
        clamp: {
            type: Number,
            default: 0
        },
        moreText: {
            type: String,
            default: ''
        },
        lessText: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        defaultFold: {
            type: Boolean,
            default: true
        },
        noFold: {
            type: Boolean,
            default: false
        },
        personalWebsite: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            fold: this.defaultFold,
            showMore: false,
            styleObject: {},
            height: 0
        };
    },
    watch: {
        height() {
            this.collapse(this.fold, true);
        },
        content() {
            this.calcHeight();
        }
    },
    async mounted() {
        if (!this.noFold) {
            this.lineHeight = await this.syncGetLineHeight(0)
            this.calcHeight();
            global.resize(this.calcHeight);
        }
    },
    computed: {
        showMoreOrLess() {
            return this.fold
                ? this.moreText || this.$t('viewMore.moreText')
                : this.lessText || this.$t('viewMore.lessText');
        }
    },
    methods: {
        syncGetLineHeight(i = 0) {
            return new Promise((resolve, reject) => {
                setTimeout(async() => {
                    try {
                        if (!this.$refs.ref_content) {
                            reject(24);
                            return;
                        }

                        let lineHeight = parseFloat(
                            util.getStyle(this.$refs.ref_content).lineHeight
                        );
                        
                        if (isNaN(lineHeight) && i < 30) {
                            const result = await this.syncGetLineHeight(i + 1);
                            resolve(result);
                        } else if (isNaN(lineHeight)) {
                            reject(24);
                        } else {
                            resolve(lineHeight);
                        }
                    } catch (error) {
                        reject(error);
                    }
                }, 100)
            })
        },
        async calcHeight() {
            if (!util.isNumber(this.lineHeight)) {
                return
            }
            this.showMore = false
            await this.$nextTick()
            this.height = this.platform.isMobile
                ? this.mobileLine * this.lineHeight
                : this.line * this.lineHeight;

            const scrollHeight = this.$refs.ref_content.scrollHeight;
            if (scrollHeight > this.height + 5) {
                this.showMore = true;
            } else {
                this.showMore = false;
            }
        },
        collapse(fold, noScroll) {
            const styleObject = {};
            if (fold) {
                styleObject.height = this.height + 'px';
                if (this.clamp) {
                    styleObject.webkitLineClamp = this.clamp;
                }
                !noScroll &&
                    this.$nextTick(() => {
                        if (!util.isOnView(this.$el)) {
                            util.scrollIntoView(this.$el, true);
                        }
                    });
            } else {
                styleObject.height = 'auto';
            }
            this.styleObject = styleObject;
            this.fold = fold;
            this.$emit('collapse', fold);
            this.$nextTick(() => {
                global.scroll('trigger');
            });
        }
    },
    unmounted() {
        !this.noFold && global.resize(this.calcHeight, true);
    }
};
</script>

<style lang="scss">
.view-more {
    position: relative;
    .view-more-content {
        overflow: hidden;
        line-height: 24px;
        white-space: pre-wrap;
    }
    .more-btn {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
    }
    &.bottom-center {
        .more-btn {
            text-align: center;
        }
    }
    &.end {
        .more-btn {
            position: absolute;
            bottom: 0;
            right: 0;
            padding-left: 10px;
        }
    }
}
</style>
